import React from 'react';
import InfoCard from './InfoCard.js';
import { GoTopViewGraphic } from '../../../../images/LandingPageNYC/NYCImageLinks';

const Heading = ({ header, cards, pro }) => (
  <div className="autzu-fleets-why-drive__container">
    <div className="autzu-fleets-why-drive__content--desktop">
      <div className="autzu-fleets-why-drive__column">
        <div className="autzu-fleets-why-drive__column--nyc"> {header}</div>
        <div className="autzu-fleets-why-drive__column--sub">
          <div className={`autzu-fleets-why-drive__vehicle--${pro ? 'pro' : 'plus'}`}>
            <div className="toronto-vehicle-types__plus">
              <img
                className="toronto-vehicle-types__car-image toronto-vehicle-types__car-image--dodge"
                src={GoTopViewGraphic}
                alt=""
              />
            </div>
          </div>
          <div className="autzu-fleets-why-drive__column--card">
            <InfoCard cardContent={cards[0]} />
            <InfoCard cardContent={cards[1]} />
          </div>
        </div>
      </div>
      <div className="autzu-fleets-why-drive__column">
        <div className="autzu-fleets-why-drive__column--card">
          <InfoCard cardContent={cards[2]} />
          <InfoCard cardContent={cards[3]} />
          <div style={{ fontSize: '11px', fontStyle: 'italic', paddingTop: '1em', paddingLeft: '30px' }}>
            <a className="go_terms" href="https://nyc.drivewithvia.com/metris500/" target="_blank">
              * Terms and conditions apply
            </a>
          </div>
        </div>
      </div>
    </div>
    <div className="autzu-fleets-why-drive__content--mobile">
      <div className="autzu-fleets-why-drive__column">
        <div className="autzu-fleets-why-drive__column--nyc"> {header}</div>
        <InfoCard cardContent={cards[0]} />
        <InfoCard cardContent={cards[1]} />
        <InfoCard cardContent={cards[2]} />
        <InfoCard cardContent={cards[3]} />
        <div style={{ fontSize: '11px', fontStyle: 'italic', paddingTop: '1em' }}>
          <a className="go_terms" href="https://nyc.drivewithvia.com/metris500/" target="_blank">
            * Terms and conditions apply
          </a>
        </div>
      </div>
    </div>
  </div>
);

export default Heading;



// WEBPACK FOOTER //
// ./src/components/Static/NYCFleets/Shared/WhyDrive.js